import styled from "styled-components";

export default c => styled(c)`
  .bold-text {
    font-weight: 700;
  }

  .select-all-row {
    font-size: 1.1em;
    background-color: white;
    margin: 4px 1px;
    padding: 8px;
    border-radius: 3px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/data-table/style.js